import {STORE_USERS} from "../action-lists";
import {getDefaultUsers} from "../state/Users";


const saveUsersInState = (state, action) => {
    return action.users;
}

export default function usersReducer(state = getDefaultUsers(), action = {}) {
    const actionHandlers = {
        [STORE_USERS]: saveUsersInState
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}